import { NgModule } from '@angular/core';
import { SharedModule } from "app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { CoreModule } from 'app/core/core.module';
import { QUESTION_ROUTES } from './question.routing';
import { QuestionDetailsComponent } from './component/question-details/question-details.component';
import { AddQuestionComponent } from './component/add-question/add-question.component';
import { QuestionListComponent } from './component/question-list/question-list.component';
import { QuestionService } from './services/question.service';
import { QuestionBankListComponent } from './component/question-bank-list/question-bank-list.component';
import { QuestionBankDetailsComponent } from './component/question-bank-details/question-bank-details.component';
import { AddQuestionBankComponent } from './component/add-question-bank/add-question-bank.component';
import { QuestionBankQuestionAddComponent } from './component/question-bank-question-add/question-bank-question-add.component';
import { QuestionBankQuestionListComponent } from './component/question-bank-question-list/question-bank-question-list.component';
import { AddQuestionAnswerComponent } from './component/add-question-answer/add-question-answer.component';
import { QuestionDetailAddQuestionToQuestionBankComponent } from './component/question-detail-add-question-to-question-bank/question-detail-add-question-to-question-bank.component';

@NgModule({
	imports: [
        CoreModule,
        SharedModule,
        RouterModule.forChild(QUESTION_ROUTES)
	],
    declarations: [
        QuestionBankListComponent,
        QuestionBankDetailsComponent,
        AddQuestionBankComponent,
        QuestionListComponent,
        AddQuestionComponent,
        QuestionDetailsComponent,
        QuestionBankQuestionAddComponent,
        QuestionBankQuestionListComponent,
        AddQuestionAnswerComponent,
        QuestionDetailAddQuestionToQuestionBankComponent
    ],
    providers: [QuestionService]
})
export class QuestionModule { }
